import { addSharePointLink, removeSharingLink } from '../actions/publicActions';
import createLinkModel from '../selectors/createLinkModel';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
mutator(addSharePointLink, function (actionMessage) {
    var store = getStore();
    var linkModel = createLinkModel(actionMessage.linkId, actionMessage.response);
    store.sharingLinks.set(actionMessage.linkId, linkModel);
});
mutator(removeSharingLink, function (actionMessage) {
    var store = getStore();
    store.sharingLinks.delete(actionMessage.linkId);
});
//# sourceMappingURL=sharingLinksMutators.js.map